package com.partejar.app.feature.profile.data

data class UserProfile(
    val id: Long,
    val name: String,
    val cpf: String?,
    val email: String
)

interface UserProfileDataSource {
    suspend fun get(): UserProfile
    suspend fun update(name: String, cpf: String?): UserProfile
    suspend fun registrations(): List<UserProfessionalRegistration>
    suspend fun createRegistration(input: UserProfessionalRegistrationInput): UserProfessionalRegistration
    suspend fun updateRegistration(id: Long, input: UserProfessionalRegistrationInput): UserProfessionalRegistration
    suspend fun deactivateRegistration(id: Long)
}

data class UserProfessionalRegistration(val id: Long, val category: String, val council: String, val number: String, val state: String, val active: Boolean) { val label get() = "$council-$state $number" }
data class UserProfessionalRegistrationInput(val category: String, val council: String, val number: String, val state: String)
